import { ActionIcon, Tooltip } from '@mantine/core';
import { IconBrandWhatsapp } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { trackWhatsappShareClicked } from '../../../Services/Mixpanel/events';
import {
  buildPermalink,
  buildWhatsAppMessage,
  buildWhatsAppShareUrl,
} from '../../../Utils/whatsappShare';

import { Props } from './ShareToWhatsAppButton.types';

const ShareToWhatsAppButton = ({ assetName, excerpt, target, trackingSource }: Props) => {
  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();

    const permalink = buildPermalink(target);
    const message = buildWhatsAppMessage({
      assetName,
      excerpt,
      permalink,
      importantLabel: t('share.whatsapp.importantInfo'),
      detailsLabel: t('share.whatsapp.seeDetails'),
    });
    const url = buildWhatsAppShareUrl(message);

    trackWhatsappShareClicked({ source: trackingSource, target_kind: target.kind });
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip label={t('share.whatsapp.tooltip')}>
      <ActionIcon variant={'subtle'} aria-label={t('share.whatsapp.aria')} onClick={handleClick}>
        <IconBrandWhatsapp size={20} />
      </ActionIcon>
    </Tooltip>
  );
};

export default ShareToWhatsAppButton;
